











import { Component, Vue } from 'vue-property-decorator'
import { bus } from '../main'
import AppNavigation from '../components/AppNavigation.vue'

@Component({
	components: {
		AppNavigation
	}
})
export default class Portal extends Vue {
	contentLoaded: boolean = false

	mounted() {		
		bus.$on('backToTop', () => {
			if ((<any>Element.prototype).scrollTo) {
				(<any>this.$refs.portal).scrollTo({top: 0, behavior: 'smooth'})
			} else {
				(<any>this.$refs.portal).scrollTop = 0
			}
		})
		bus.$on('routeChange', () => {
			this.contentLoaded = false
			
			setTimeout(() => {
				if (this.$refs.portal) {
					(<any>this.$refs.portal).scrollTo(0,0)
				}
			}, 200)
		})
		bus.$on('initCompleteContent', () => {
			this.contentLoaded = true

			bus.$emit('initComplete')
		})
	}
	beforeDestroy() {
		bus.$off('backToTop')
		bus.$off('routeChange')
		bus.$off('initCompleteContent')
	}
}
